module.exports = __webpack_public_path__ + "img/pingtai3.aaf3ad0b.png";